import React from 'react';
import { components } from 'react-select';

const Input = ({ children, ...props }) => {
  const { selectProps } = props;

  return (
    <components.Input
      {...props}
      required={selectProps.required ? true : undefined}
      title={`${selectProps.options.length} results available. Use Up and Down to choose options, press Enter to select the currently focused option, press backspace to clear selection and press Escape to exit the menu`}
    />
  );
};

export default Input;
